export default {
    app: null,
    page: null,
    setPage(page) {
        this.page = page

        if (this.page && this.app) {
            this.app.hidePageLayout = this.page.hidePageLayout
            this.app.title = this.page.name
        }
    }
}